import { TextField } from '@material-ui/core';
import styled from 'styled-components';

export const StyledTextField = styled(TextField)`
  margin: ${(props) => (props.disableMargin ? '0px' : '0 10px 10px 0')};
  width: ${(props) => props.width || '240px'};
`;
